import { createAsyncThunk } from '@reduxjs/toolkit';
import { appActions } from 'in-meeting-experience-ui-components/contexts/app/context';
export const portalUserInfo = createAsyncThunk('auth/portalUserInfo', (isAutoRefresh, thunkAPI) => thunkAPI.extra.authApi.fetchPortalUserInfo().then(response => {
  if (isAutoRefresh) return undefined;
  appActions.setScopes({
    scopes: response.portal.scopes,
    scopeGroups: response.tokenInfo.scopeGroups
  });
  return response;
}).catch(error => thunkAPI.rejectWithValue(error)));
export const userInfo = createAsyncThunk('auth/userInfo', (_, thunkAPI) => thunkAPI.extra.authApi.fetchUserInfo({}).catch(error => thunkAPI.rejectWithValue(error)));